export const DetailsFormFields = {
  userStatus: 'userStatus',
  businessRole: 'businessRole',
} as const;
